import React from 'react';
import { companies as mockCompanies } from '../mock';
import { useApp } from '../context/AppContext';
import { TrendingUp, TrendingDown } from 'lucide-react';

export default function TickerTape() {
  const { companies } = useApp();
  const source = (companies && companies.length ? companies : mockCompanies).filter((c) => !c.hidden);
  const items = [...source, ...source];
  return (
    <div className="w-full bg-[#0d0d10] border-b border-[var(--border-soft)] overflow-hidden">
      <div className="flex whitespace-nowrap animate-ticker py-2">
        {items.map((c, i) => {
          const up = c.change >= 0;
          return (
            <div key={i} className="flex items-center gap-2 px-6 text-[11px] font-mono">
              <span className="text-[var(--muted)] tracking-wider">{c.ticker}</span>
              <span className="text-[var(--text)]">${c.lastPrice.toFixed(2)}</span>
              <span className={`flex items-center gap-0.5 ${up ? 'text-[var(--green)]' : 'text-[var(--red)]'}`}>
                {up ? <TrendingUp size={11} /> : <TrendingDown size={11} />}
                {up ? '+' : ''}{c.change.toFixed(2)}%
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
